// src/hooks/hotelRoomCategories/useGetHotelRoomCategory.js
import { useQuery } from "@tanstack/react-query";
import { getHotelRoomCategory } from "../../api/apiHotelRoomCategories";

const QUERY_KEY = ["hotelRoomCategory"];

const useGetHotelRoomCategory = (id) => {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: [...QUERY_KEY, id],
    queryFn: () => getHotelRoomCategory(id),
    enabled: !!id,
  });

  return {
    isLoading,
    error: isError ? error : null,
    hotelRoomCategory: data?.data || null,
  };
};

export default useGetHotelRoomCategory;
